import {css} from 'styled-components';

export const font = {
    text: (weight: number = 400) => css`
      font-family: Poppins, sans-serif;
      font-style: normal;
      font-weight: ${weight};
    `
};
